module.exports = __webpack_public_path__ + "img/img1.8259b3b1.png";